export default "__VITE_ASSET__iDa3x1TA__"